export default __webpack_public_path__ + "static/media/nodejs.0f5c1eec.svg";